export default [
  {
    header: 'ระบบงานอื่น ๆ',
    menu: 'Others',
  },
  {
    title: 'ระบบออกตรวจผู้ประกอบธุรกิจ',
    route: 'Verify',
    icon: 'MenuIcon',
    menu: 'Entrepreneur',
  },
  {
    title: 'ระบบจัดสรรค์งบประมาณ',
    route: null,
    icon: 'EyeOffIcon',
    menu: 'Funds',
  },
  // {
  //   title: 'ประวัติการใช้งาน',
  //   route: 'AppLog',
  //   icon: 'CircleIcon',
  //   menu: 'AppLog',
  // },

]
